import { axiosSwagger } from "@/axios";

export const state = {
    accessLevel: {
        loading: false,
        data: [],
        total: 0,
    },
}


export const getters = {
}


export const mutations = {
    // ACCESS LEVEL
    loading: (state, loading) => {
        state.accessLevel.loading = loading;
    },
    setData: (state, data) => {
        state.accessLevel.data = modifyData( data );
    },
    setTotal: (state, total) => {
        state.accessLevel.total = total;
    },
    add: (state, data) => {
        state.accessLevel.data.push(data);
    },
    remove: (state, id) => {
        state.accessLevel.data = state.accessLevel.data.filter((el) => el.id !== id);
    },
    update: (state, data) => {
        const index = state.accessLevel.data.findIndex(
            (item) => item.id === data.id
        );

        if (index !== -1) {
            state.accessLevel.data[index].access = data.access;
            state.accessLevel.data[index].description = data.description;
        }
    },
}


export const actions = {
    // ACCESS LEVEL
    async readAccessLevel({ commit }) {
        commit("loading", true);

        return await axiosSwagger
        .get("/api/AccessLevel/All")
        .then((response) => {
            commit("setData", response.data);
            commit("setTotal", response.data.length);
            commit("loading", false);

            return response;
        })
        .catch(() => {
            commit("loading", false);
        });
    },
    async createAccessLevel({ commit }, data) {
        return await axiosSwagger
        .post(`/api/AccessLevel/Add?access=${data.access}`)
        .then((response) => {
            commit("add", response.data);

            return response;
        });
    },
    async deleteAccessLevel({ commit }, id) {
        return await axiosSwagger
        .delete(`/api/AccessLevel/Remove/${id}`)
        .then((response) => {
            commit("remove", id);

            return response;
        });
    },
    async updateAccessLevel({ commit }, data) {
        return await axiosSwagger
        .put(`/api/AccessLevel/Update/${data.id}/${data.access}`)
        .then((response) => {
            commit("update", data);

            return response;
        });
    },
}

// a function that lowercase string and remove spaces
const formatString = (str) => {
    if (!str) return '';
    return str.toLowerCase().replace(/\s+/g, '');
};

const modifyData = (arrayData) => {
    if(arrayData?.length ?? false){
      
      arrayData.forEach(e => {
        const access = formatString(e.access)

        if(access === 'system'){
            e.sortLevel = 1;
        }
        else if(access === 'deliveryunit' || access === 'department'){
            e.sortLevel = 2;
        }
        else if(access === 'office'){
            e.sortLevel = 3;
        }
        else if(access === 'campus' || access === 'lgu'){
            e.sortLevel = 4;
        }
        else if(access === 'public'){
            e.sortLevel = 5;
        }
        else {
            e.sortLevel = 0;
        }
      });
  
      return arrayData;
    }
  
    return [];
  };